"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const valueIsControlsControlEventDefinition_1 = __importDefault(require("./valueIsControlsControlEventDefinition"));
const valueIsRuntimeEntryVar_1 = __importDefault(require("./valueIsRuntimeEntryVar"));
const valueIsFunctionsListModification = (0, ts_validators_1.buildValueIsShape)('ListModification', {
    events: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        (0, ts_validators_1.buildValueIsArrayOf)(valueIsControlsControlEventDefinition_1.default),
    ]),
    persist: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        ts_validators_1.valueIsBoolean,
    ]),
    props: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        (0, ts_validators_1.buildValueIsRecordOf)((0, ts_validators_1.buildRecursiveValidator)(() => valueIsRuntimeEntryVar_1.default)),
    ]),
});
exports.default = valueIsFunctionsListModification;
